import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const pains = ["You have NDIS (or you're in the process) and you still feel lost.", 'You open Facebook groups, save posts, and end up more confused.', "You call providers and they say 'no spots available' (again).", "You have PDFs everywhere but don't know which document is for what.", "You're terrified you're wasting time your child can't get back."];
export function PainPoints() {
  return <section className="py-20 bg-white" data-id="element-86">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl" data-id="element-87">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-88">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-navy-900 mb-4" data-id="element-89">
            If this sounds like you...
          </h2>
          <div className="h-1 w-20 bg-teal-500 mx-auto rounded-full" data-id="element-90"></div>
        </motion.div>

        <div className="space-y-6" data-id="element-91">
          {pains.map((pain, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start p-4 rounded-lg hover:bg-cream-50 transition-colors duration-300" data-id="element-92">
              <XCircle className="h-6 w-6 text-red-400 mt-1 mr-4 flex-shrink-0" data-id="element-93" />
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-94">{pain}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mt-12 text-center bg-navy-900/5 p-8 rounded-2xl" data-id="element-95">
          <p className="text-xl md:text-2xl font-serif text-navy-900 italic" data-id="element-96">
            "You don't need to be stronger. You need a system that works when
            you're tired."
          </p>
        </motion.div>
      </div>
    </section>;
}